import { EMPTY_FIELD } from './constants'

export default function emptyFieldValidate(value) {
  return !value ? EMPTY_FIELD : null
}
